import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import SummaryApi from '../common';
import { Link, useNavigate } from 'react-router-dom';
import Context from "../context";
import displayINRCurrency from "../helpers/displayCurrency";
import { toast } from "react-toastify";

const Checkout = () => {
  const [address, setAddress] = useState({
    fullName: "", instagram: "", email: "", phone: "", addressLine: "", city: "", state: "", pincode: ""
  });
  const [deliveryCharge] = useState(75);
  const [amount, setAmount] = useState(0);
  const grandTotal = Number(amount) + Number(deliveryCharge);
  const [cartItems, setCartItems] = useState([]);
  const navigate = useNavigate();
  const context = useContext(Context);
  const fetchUserAddToCart = context?.fetchUserAddToCart;

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    const storedAmount = Number(localStorage.getItem("totalAmount") || 0);
    setCartItems(storedCart);
    setAmount(storedAmount);

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => { try { document.body.removeChild(script); } catch (e) {} };
  }, []);

  const handlePayment = async () => {
    if (
    !address.fullName.trim() ||
    !address.email.trim() ||
    !address.phone.trim() ||
    !address.addressLine.trim() ||
    !address.city.trim() ||
    !address.state.trim() ||
    !address.pincode.trim()
  ) {
    alert("Please fill all required address fields before continuing.");
    return;
  }
    // validate email format (simple)
  const emailRegex = /\S+@\S+\.\S+/;
  if (!emailRegex.test(address.email)) {
    toast.error("Please enter a valid email address.");
    return;
  }

  if (address.phone.length !== 10) {
    toast.error("Enter a valid 10-digit phone number");
    return;
  }

  if (address.pincode.length !== 6) {
    toast.error("Enter a valid 6-digit pincode");
    return;
  }

    try {
      const orderReq = await axios({
        url: SummaryApi.createOrder.url,
        method: SummaryApi.createOrder.method,
        data: { cartItems, deliveryCharge },
        withCredentials: true
      });

      const order = orderReq.data;

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: order.amount,
        currency: "INR",
        name: "Samartha Ornaments",
        description: "Order Payment",
        order_id: order.id,
        handler: async function (response) {
          try {
            const verifyRes = await axios({
              url: SummaryApi.verifyOrder.url,
              method: SummaryApi.verifyOrder.method,
              data: {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                orderData: { address, items: cartItems, subtotal: amount, deliveryCharge: deliveryCharge, amount: grandTotal }
              },
              withCredentials: true
            });

            const returnedOrderId =
              verifyRes.data?.orderId || verifyRes.data?.order?._id;

            localStorage.removeItem("cart");
            localStorage.removeItem("totalAmount");

            try{
            const token = localStorage.getItem("authToken");

            if (token && SummaryApi.clearCart?.url) {
              await axios({
                url: SummaryApi.clearCart.url,
                method: SummaryApi.clearCart.method || "POST",
                withCredentials: true
              });
            }
          }catch (e) {
            //console.warn("Cart clear skipped or failed:", e?.response?.data || e);
          }

            if (fetchUserAddToCart) await fetchUserAddToCart();

            navigate(returnedOrderId ? `/order-success/${returnedOrderId}` : "/");
          } catch (err) {
            alert("Payment verification failed");
          }
        },
        prefill: { name: address.fullName, contact: address.phone },
        theme: { color: "#7e22ce" }
      };

      const razor = new window.Razorpay(options);
      razor.open();
    } catch (err) {
      alert("Payment failed to start");
    }
  };

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-10 py-6">
      <h2 className="text-2xl font-semibold mt-2 mb-3 text-center text-[#5a3620] font-serif">Checkout</h2>
      <p className="text-center text-[#5a3620] font-serif mb-2">Tip: Create an account or log in to save your cart and track your orders <Link to= "/sign-up" className="underline">Click here</Link></p>

      <div className="flex flex-col lg:flex-row gap-8 justify-center">

        {/* ================= ADDRESS FORM ================= */}
        <div className="w-full lg:max-w-2xl bg-white p-5 rounded shadow">

          <h3 className="text-lg font-medium mb-4 text-[#5a3620] font-serif">Shipping Address</h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input className="border p-2 rounded"
              placeholder="Full Name*"
              value={address.fullName}
              required
              onChange={e => setAddress({ ...address, fullName: e.target.value })}
            />
            <input className="border p-2 rounded"
              placeholder="Phone*"
              value={address.phone}
              required
              onChange={e => setAddress({ ...address, phone: e.target.value })}
            />
          </div>

          <input className="border p-2 rounded w-full mt-4"
            placeholder="Address*"
            value={address.addressLine}
            required
            onChange={e => setAddress({ ...address, addressLine: e.target.value })}
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
            <input
              className="border p-2 rounded"
              placeholder="Email*"
              type="email"
              value={address.email}
              required
              onChange={e => setAddress({ ...address, email: e.target.value })}
            />
            <input
              className="border p-2 rounded"
              placeholder="Instagram ID (optional)"
              value={address.instagram}
              onChange={e => setAddress({ ...address, instagram: e.target.value })}
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
            <input className="border p-2 rounded"
              placeholder="City*"
              value={address.city}
              required
              onChange={e => setAddress({ ...address, city: e.target.value })}
            />
            <select className="border p-2 rounded"
              placeholder="State*"
              value={address.state}
              required
              onChange={e => setAddress({ ...address, state: e.target.value })}
            >
                <option value="">Select State*</option>
                <option value="Andhra Pradesh">Andhra Pradesh</option>
                <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                <option value="Assam">Assam</option>
                <option value="Bihar">Bihar</option>
                <option value="Chhattisgarh">Chhattisgarh</option>
                <option value="Goa">Goa</option>
                <option value="Gujarat">Gujarat</option>
                <option value="Haryana">Haryana</option>
                <option value="Himachal Pradesh">Himachal Pradesh</option>
                <option value="Jharkhand">Jharkhand</option>
                <option value="Karnataka">Karnataka</option>
                <option value="Kerala">Kerala</option>
                <option value="Madhya Pradesh">Madhya Pradesh</option>
                <option value="Maharashtra">Maharashtra</option>
                <option value="Manipur">Manipur</option>
                <option value="Meghalaya">Meghalaya</option>
                <option value="Mizoram">Mizoram</option>
                <option value="Nagaland">Nagaland</option>
                <option value="Odisha">Odisha</option>
                <option value="Punjab">Punjab</option>
                <option value="Rajasthan">Rajasthan</option>
                <option value="Sikkim">Sikkim</option>
                <option value="Tamil Nadu">Tamil Nadu</option>
                <option value="Telangana">Telangana</option>
                <option value="Tripura">Tripura</option>
                <option value="Uttar Pradesh">Uttar Pradesh</option>
                <option value="Uttarakhand">Uttarakhand</option>
                <option value="West Bengal">West Bengal</option>
                <option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
                <option value="Chandigarh">Chandigarh</option>
                <option value="Dadra and Nagar Haveli and Daman and Diu">
                  Dadra and Nagar Haveli and Daman and Diu
                </option>
                <option value="Delhi">Delhi</option>
                <option value="Jammu and Kashmir">Jammu and Kashmir</option>
                <option value="Ladakh">Ladakh</option>
                <option value="Lakshadweep">Lakshadweep</option>
                <option value="Puducherry">Puducherry</option>
              </select>
            
            <input className="border p-2 rounded"
              placeholder="Pincode*"
              value={address.pincode}
              required
              onChange={e => setAddress({ ...address, pincode: e.target.value })}
            />
          </div>
        </div>

        {/* ================= ORDER SUMMARY ================= */}
        <div className="w-full lg:max-w-sm">
          <div className="bg-white rounded shadow sticky top-24">

            <h3 className="bg-[#5a3620] text-white px-4 py-2 rounded-t font-serif">
              Order Summary
            </h3>

            <div className="p-4 space-y-2 text-sm font-serif text-[#5a3620]">
              {cartItems.length === 0 ? (
                <p>No items in cart</p>
              ) : cartItems.map((it, i) => (
                <div key={i} className="flex justify-between">
                  <span>{it.name} × {it.qty}</span>
                  <span>{displayINRCurrency(it.price * it.qty)}</span>
                </div>
              ))}
            </div>

            <div className="border-t px-4 py-1 flex justify-between font-semibold text-[#5a3620]">
              <span>Sub Total</span>
              <span>{displayINRCurrency(amount)}</span>
            </div>

            <div className="px-4 py-1 flex justify-between font-semibold text-[#5a3620]">
              <span>Delivery Charges</span>
              <span>{displayINRCurrency(deliveryCharge)}</span>
            </div>

            <div className="px-4 py-3 flex justify-between font-bold text-lg text-[#5a3620]">
              <span>Total Payable</span>
              <span>{displayINRCurrency(grandTotal)}</span>
            </div>

            <button
              onClick={handlePayment}
              className="bg-[#5a3620] text-white w-full py-3 rounded-b transition font-serif"
            >
              Proceed to Pay
            </button>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Checkout;
